export default __webpack_public_path__ + "bdc4bd7fc18d1daf44ed6cac68e1c7e1.png";